module.exports = __webpack_public_path__ + "img/categoria-3.2c402819.png";